import moment from "moment";

export const formatDateInput = (dateString) => {
  const [year, month, day] = dateString.split("-");
  return `${day}-${month}-${year}`;
};

export const formatDateOutput = (dateString) => {
  return moment(dateString).format("DD-MMM-YYYY");
};
